import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'

export default function Companymemberpage() {
    const navigate = useNavigate();
    const [companyname, setCompanyname] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [listMembersArray, setListMembersArray] = useState([]);
    const [permissions, setPermissions] = useState([]);
    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];
        setPermissions(storedPermissions);
        let comname = localStorage.getItem('mem_company_name');
        setCompanyname(comname);
        let com_id = localStorage.getItem('mem_company_id');

        var obj = {
            com_id: com_id
        };

        console.log(obj);

        fetch('getAllCompanyMember.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // ✅ auto JSON parse
            .then(res => {
                console.log(res);

                if (res !== 'fail' && res) {
                    // ensure it's an array
                    if (Array.isArray(res)) {
                        let len = res.length;

                        if (len < 1) {
                            showAlert('Cannot find any member.');
                            setListMembersArray([]);
                        } else {
                            setListMembersArray(res);
                        }
                    } else {
                        setListMembersArray([]);
                    }
                } else {
                    showAlert('Cannot find any member.');
                    setListMembersArray([]);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
                setListMembersArray([]);
            });
    }, [])

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function removeMem(id) {
        var obj = {
            primary_key: id
        };

        fetch('removeComMem.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.text()) // because PHP returns "1" or "fail"
            .then(result => {
                if (result !== 'fail') {
                    showAlert('Removed successfully');
                    navigate('/redirect_team');
                } else {
                    showAlert('Cannot remove member.');
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }

    function Viewdetails(id) {
        localStorage.setItem('selectedComMemberID', id);
        navigate('/member_details');
    }
    function ViewMemberTimetrack(id) {
        localStorage.setItem('selectedComMemberID', id);
        navigate('/company_member_timetrack');
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <button className='tabs'>All Members List of {companyname} </button>
                    <Link className='pull_right add_new_pro adminuse' to="/add_member">Add New Member</Link>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='vl_listing_area'>
                        <div className='vl_listing_row'>
                            <div className='vl_listing_cell width20'>
                                <h4 className='prj_name'>First Name</h4>
                            </div>
                            <div className='vl_listing_cell width20'>
                                <p>Last Name</p>
                            </div>

                            <div className='vl_listing_cell width20'>
                                <p>Email</p>
                            </div>
                            <div className='vl_listing_cell width15'>
                                <p>Phone</p>
                            </div>
                            <div className='vl_listing_cell width25'>
                                <p>Action</p>
                            </div>
                        </div>
                        {Array.isArray(listMembersArray) && listMembersArray.map((item, index) => {

                            return (
                                <div className='vl_listing_row'>
                                    <div className='vl_listing_cell width20' key={index}>
                                        <h4 className='prj_name'>{item.mem_fname}</h4>
                                        <input id="member_main_id" type="hidden" value={item.emp_auto_id} />
                                        <input id="member_primary_key" type="hidden" value={item.primary_key} />
                                        <span>Role : {item.mem_role}</span>
                                        <span>Registration Date & Time : {item.reg_dt_tm}</span>
                                        <span>Activation : {item.mem_activation}</span>
                                    </div>


                                    <div className='vl_listing_cell width20'>
                                        <p>{item.mem_lname}</p>
                                    </div>
                                    <div className='vl_listing_cell width20'>
                                        <p>{item.mem_email}</p>
                                    </div>
                                    <div className='vl_listing_cell width15'>
                                        <p>{item.mem_phone}</p>
                                    </div>
                                    {permissions.includes("user.manage") && (
                                        <div className='vl_listing_cell width25'>

                                            <button className='rightgap backtranparent' onClick={() => { removeMem(item.primary_key) }}><i className='ri-delete-bin-3-fill'></i></button>

                                            <button className='rightgap' onClick={() => { Viewdetails(item.primary_key) }}>View Details</button>
                                            <button className='rightgap greenbutton adminuse' onClick={() => { ViewMemberTimetrack(item.primary_key) }}>Time Chart <i className='ri-time-line'></i></button>
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>

        </div>
    )
}
